import React, { useEffect, useState } from 'react'
import moment from 'moment-timezone'
import { Container } from 'react-grid-system'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Spinner, Dialog, Classes, Button } from '@blueprintjs/core'
import { DatePicker } from '@blueprintjs/datetime'
import Schedule from './schedule'
import TopBar from '../layout/top-bar/top-bar'
//import Footer from '../layout/footer/footer'
//import Login from '../login/login'
import usersService from '../../api-services/users-service'
import patientsService from '../../api-services/patients-service'
import organizationsService from '../../api-services/organizations-service'
import packsService from '../../api-services/packs-service'

import { patientsApi } from '../../api'
import { serverErrorToast, errorToast, successToast } from '../layout/toaster/toaster'
import { packScheduleThrifty28days, packScheduleJones7days } from '../../config/defaultSchedules'

import css from './patient.module.css'

function Patient( { currentPatient }) {
  let [users, setUsers] = useState(null)
  let [patient, setPatient] = useState()
  let [isStartDateDialogOpen, setStartDateDialogOpen] = useState(false)
  let [startDate, setStartDate] = useState()
  let [rxId, setRxId] = useState('')
  let [clientId, setClientId] = useState('')

  async function fetch (p) {
    try {
      if (!p.subscriptionStartDate) {
        setStartDateDialogOpen(true)
      }

      if (!p.packSchedule) {
        // Support more types of packs and default to 7 days if nothing is found
        if ((!p.packType || p.packType === 'jones7days') && !p.packSchedule?.weeks) {
          p.packSchedule = packScheduleJones7days
        } else if ((!p.packType || p.packType === 'us_7days') && !p.packSchedule?.weeks) {
          p.packSchedule = packScheduleJones7days
        } else if ((!p.packType || p.packType === 'ca_7days') && !p.packSchedule?.weeks) {
          p.packSchedule = packScheduleJones7days
        } else if ((!p.packType || p.packType === 'us_dispill') && !p.packSchedule?.weeks) {
          p.packSchedule = packScheduleJones7days
        } else if (p.packType === 'thrifty28days' && !p.packSchedule?.packs) {
          p.packSchedule = packScheduleThrifty28days
        } else {
          p.packSchedule = packScheduleJones7days
        }
      }

      if (p.hca) {
        setRxId(p.hca.shortId)
      }

      setClientId(p.medId)
      setPatient(p)

      if (p.version === 'v3') {
          const users = await usersService.fetch({patientId: p._id})
          setUsers(users)
        } else {
          setUsers([])
        }
    } catch (err) {
      setPatient(null)
      setUsers([])
      serverErrorToast(err, true)
    }
  }

  useEffect(() => {
    setPatient(null)
    setUsers(null)

    if (!currentPatient) {
      return
    }

    fetch(currentPatient)
  }, [currentPatient])


  const createParticipant = async (body) => {
    const bodyData = {
      firstName: body.firstName,
      lastName: body.lastName,
      name: body.firstName + body.lastName,
      email: body.email,
      patientId: body.patientId,
      type: 'patient',
      // organizationId: body.organizationId,
      // organizationName: body.organizationName,
      password: body.password
    }

    if (!bodyData.email) {
      alert('Email is missing')
      return
    }

    if (!bodyData.password || bodyData.password.length < 8) {
      alert('Password must be at least 8 characters')
      return
    }

    let successText = 'Successfuly created gateway user ' + bodyData.firstName + ' ' + bodyData.lastName
    try {
      const { data } = await usersService.post(bodyData)
      alert(successText)

      const users = await usersService.fetch({patientId: patient._id})
      setUsers(users)
    } catch (error) {
      successText = 'Failed to create user ' + bodyData.firstName + ' ' + bodyData.lastName
      alert(successText)
    }
  }

  const deleteParticipant = async (u) => {
    try {
      let successText = 'Successfully removed user ' + u.firstName + ' ' + u.lastName
      const { data } = await organizationsService.post('deleteUser', { userId: u._id })
      if (!data) {
        successText = 'Failed to delete user ' + u.firstName + ' ' + u.lastName
      }
      alert(successText)
      const userData = await organizationsService.get(`${data.patientId}`)
      setUsers(userData.data)
    } catch (error) {
      const errorText = 'Failed to delete user ' + u.firstName + ' ' + u.lastName
      alert(errorText)
    }
  }

  const saveAssignParticipant = async (body) => {
    let errorText = 'Failed to assign participant with StickerId:' + body.stickerId + ', recordId:' + body.recordId + '.  Please ensure the pack is activated and assigned to the Sticker Id.  Please contact CuePath for further assistance.'
    try {
      setPatient(false)

      const bodyData = {
        stickerId: body.stickerId,
        recordId: body.recordId,
        event: body.event,
        patientId: body.patientId,
        repeatInstanceId: body.repeatInstanceId
      }

      if (bodyData.stickerId === '' || bodyData.recordId === '') {
        errorText = 'Failed to assign participant.  Please ensure stickerId and recordId are valid entries'
        alert(errorText)
        errorToast(errorText)
        return
      }

      const { data } = await packsService.post('setParticipantInfo', bodyData)
      if (data) {
        const successText = 'Successfuly assigned participant with StickerId:' + body.stickerId + ' RecordId:' + bodyData.recordId + ' EventName:' + bodyData.event + ' repeatInstanceId:' + bodyData.repeatInstanceId
        alert(successText)
        successToast(
          successText
        )
      } else {
        alert(errorText)
        errorToast(errorText)
      }
    } catch (err) {
      alert(errorText)
      errorToast(errorText)
      setPatient(null)
    } finally {
      setPatient(body.patient)
    }
  }

  const savePatient = async (body) => {
    try {
      const lightPatient = {
        _id: body?._id,
        packSchedule: body?.packSchedule,
        subscriptionStartDate: body?.subscriptionStartDate
      }

      await patientsService.patch(lightPatient._id, lightPatient)
     // const { data } = await patientsApi.patch(`rx/${rxId}/${clientId}`, body)

      successToast(
        'The schedule was successfully updated. If you made changes to current week, it will be applied tomorrow.'
      )
    } catch (err) {
      setPatient(null)
      serverErrorToast(err)
    }
  }

  if (!patient || !users) {
    return <Spinner />
  }

  return (
    <>
      <TopBar
        users={users}
        patient={patient}
        rxId={rxId}
        //setRxId={setRxId}
        clientId={clientId}
        //setClientId={setClientId}
        //fetchData={fetch}
      />
      <Container style={{ maxWidth: 1200 }} className={css.content}>
        <Switch>
          <Route path="/">
            <Schedule patient={patient} users={users} savePatient={savePatient} saveAssignParticipant={saveAssignParticipant} createParticipant={createParticipant} deleteParticipant={deleteParticipant}/>
          </Route>
        </Switch>
      </Container>

      {/*
      <Footer />
      */}

      <Dialog
        icon="info-sign"
        title="Prescription Start Date"
        isOpen={isStartDateDialogOpen}
        isCloseButtonShown={false}
      >
        <div className={Classes.DIALOG_BODY}>
          <p>
            <strong>
              Please set prescription start date for this patient, specifying when the first pack should be started.
            </strong>
          </p>
          <div style={{ alignItems: 'center', flexDirection: 'column', display: 'flex' }}>
            <DatePicker
              className={Classes.ELEVATION_1}
              onChange={(v) => setStartDate(v)}
              maxDate={moment().add(12, 'month').toDate()}
            />
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              disabled={!startDate}
              onClick={() => {
                savePatient({ ...patient, subscriptionStartDate: startDate })
                setStartDateDialogOpen(false)
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default Patient
